export default __webpack_public_path__ + "static/o2o-logo-r-72092e078076fc622cbc25969284f288.png";